import { createAction, props } from "@ngrx/store";

import { DocumentRequestQuery, DocumentRequestResponse } from "./request.model";

export const getRequests = createAction(
  "[Request] Get Requests",
  props<DocumentRequestQuery>()
);

export const getRequestsSuccess = createAction(
  "[Request] Get Requests Success",
  props<DocumentRequestResponse>()
);

export const getRequestsFailure = createAction(
  "[Request] Get Requests Failure",
  props<{ regionName: string }>()
);
